<template>
    <div class="TTL-Genealogy">
        <div class="TTL-Genealogy-title">
            <el-form :inline="true">
                <el-form-item>
                <a class="TTL-fresh" @click="freshInit"></a>
                </el-form-item>
                <el-form-item>
                <div class="TTL-select">
                <el-select v-model="Genealogy.id" class="m-2" @change="changeGenealogy" placeholder="请选择族谱" size="large" clearable filterable >
                <el-option
                    v-for="(item,index) in Genealogylists"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                    clearable
                />
                </el-select>
                </div>
                </el-form-item>
                <el-form-item>
                <el-button type="warning" size="large" round @click="addChairman">新增族长</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>


    <!-- 族成员信息 -->
    <div class="tree" v-loading="Genealogy.loading">

        <!-- 空数据 -->
        <div v-if="Treedata.length==0" class="TTL-table-no-data"><el-empty description="暂无数据" /></div>

        <!-- 一级 -->
        <ul v-if="Treedata.length > 0">
            <li v-for="(oneitem,index) in Treedata">
                <div class="tree-detail-images">
                    <div class="avar">
                        <el-image
                            width="100"
                            height="100"
                            :src="oneitem.image_url ? oneitem.image_url : require('@/assets/avatar/avatar_default.png')"
                            :zoom-rate="1.2"
                            :preview-src-list="oneitem.image_url ? [oneitem.image_url] : []"
                            :initial-index="10"
                            :z-index="15"
                            fit="cover"
                        />
                        <div class="TTL-setting-image-btn">
                        <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(oneitem)" />
                        </div>
                        <div class="TTL-btn-delete">
                        <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(oneitem)" />
                        </div>
                        <div class="TTL-btn-add">
                        <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(oneitem)" />
                        </div>
                        <div class="TTL-btn-see">
                            <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                            <div class="TTL-genealogy-show">
                                <div class="TTL-genealogy-show-img">
                                    <el-image
                                        :src="oneitem.image_url ? oneitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                        :zoom-rate="1.2"
                                        :initial-index="10"
                                        :z-index="15"
                                        fit="cover"
                                    />
                                </div>
                                <el-row><span>成员名字：{{oneitem.name}}</span></el-row>
                                <el-row v-if="oneitem.othername"><span>其他名字：{{oneitem.othername}}</span></el-row>
                                <el-row><span>成员性别：{{oneitem.sex==0 ? '男' : '女'}}</span></el-row>
                                <el-row><span>成员背景：{{oneitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                <el-row><span>成员职业 / 生前职业：{{oneitem.work}}</span></el-row>
                                <el-row v-if="oneitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                <el-row><span>成员描述：{{oneitem.description}}</span></el-row>
                                <el-row v-if="oneitem.grave_area">
                                <span>埋葬地点：{{oneitem.grave_area}}</span>
                                <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                </el-row>
                            </div>
                            <template #reference>
                            <el-button size="small" type="warning" icon="View" circle />
                            </template>
                            </el-popover>
                        </div>
                    </div>
                </div>
                <div class="TTL-genealogy-name">{{oneitem.name}}</div>

                <!-- 二级 -->
                <ul v-if="oneitem.children && oneitem.children.length > 0">
                    <li v-for="(towitem,index) in oneitem.children">
                        <div class="tree-detail-images">
                            <div class="avar">
                                <el-image
                                    width="100"
                                    height="100"
                                    :src="towitem.image_url ? towitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                    :zoom-rate="1.2"
                                    :preview-src-list="towitem.image_url ? [towitem.image_url] : []"
                                    :initial-index="10"
                                    :z-index="15"
                                    fit="cover"
                                />
                                <div class="TTL-setting-image-btn">
                                <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(towitem)" />
                                </div>
                                <div class="TTL-btn-delete">
                                <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(towitem)" />
                                </div>
                                <div class="TTL-btn-add">
                                <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(towitem)" />
                                </div>
                                <div class="TTL-btn-see">
                                    <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                    <div class="TTL-genealogy-show">
                                        <div class="TTL-genealogy-show-img">
                                            <el-image
                                                :src="towitem.image_url ? towitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                :zoom-rate="1.2"
                                                :initial-index="10"
                                                :z-index="15"
                                                fit="cover"
                                            />
                                        </div>
                                        <el-row><span>成员名字：{{towitem.name}}</span></el-row>
                                        <el-row v-if="towitem.othername"><span>其他名字：{{towitem.othername}}</span></el-row>
                                        <el-row><span>成员性别：{{towitem.sex==0 ? '男' : '女'}}</span></el-row>
                                        <el-row><span>成员背景：{{towitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                        <el-row><span>成员职业 / 生前职业：{{towitem.work}}</span></el-row>
                                        <el-row v-if="towitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                        <el-row><span>成员描述：{{towitem.description}}</span></el-row>
                                        <el-row v-if="towitem.grave_area">
                                        <span>埋葬地点：{{towitem.grave_area}}</span>
                                        <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                        </el-row>
                                    </div>
                                    <template #reference>
                                    <el-button size="small" type="warning" icon="View" circle />
                                    </template>
                                    </el-popover>
                                </div>
                            </div>
                        </div>
                        <div class="TTL-genealogy-name">{{towitem.name}}</div>

                        <!-- 三级 -->
                        <ul v-if="towitem.children && towitem.children.length > 0">
                            <li v-for="(threeitem,index) in towitem.children">
                                <div class="tree-detail-images">
                                    <div class="avar">
                                        <el-image
                                            width="100"
                                            height="100"
                                            :src="threeitem.image_url ? threeitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                            :zoom-rate="1.2"
                                            :preview-src-list="threeitem.image_url ? [threeitem.image_url] : []"
                                            :initial-index="10"
                                            :z-index="15"
                                            fit="cover"
                                        />
                                        <div class="TTL-setting-image-btn">
                                        <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(threeitem)" />
                                        </div>
                                        <div class="TTL-btn-delete">
                                        <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(threeitem)" />
                                        </div>
                                        <div class="TTL-btn-add">
                                        <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(threeitem)" />
                                        </div>
                                        <div class="TTL-btn-see">
                                            <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                            <div class="TTL-genealogy-show">
                                                <div class="TTL-genealogy-show-img">
                                                    <el-image
                                                        :src="threeitem.image_url ? threeitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                        :zoom-rate="1.2"
                                                        :initial-index="10"
                                                        :z-index="15"
                                                        fit="cover"
                                                    />
                                                </div>
                                                <el-row><span>成员名字：{{threeitem.name}}</span></el-row>
                                                <el-row v-if="threeitem.othername"><span>其他名字：{{threeitem.othername}}</span></el-row>
                                                <el-row><span>成员性别：{{threeitem.sex==0 ? '男' : '女'}}</span></el-row>
                                                <el-row><span>成员背景：{{threeitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                                <el-row><span>成员职业 / 生前职业：{{threeitem.work}}</span></el-row>
                                                <el-row v-if="threeitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                                <el-row><span>成员描述：{{threeitem.description}}</span></el-row>
                                                <el-row v-if="threeitem.grave_area">
                                                <span>埋葬地点：{{threeitem.grave_area}}</span>
                                                <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                                </el-row>
                                            </div>
                                            <template #reference>
                                            <el-button size="small" type="warning" icon="View" circle />
                                            </template>
                                            </el-popover>
                                        </div>
                                    </div>
                                </div>
                                <div class="TTL-genealogy-name">{{threeitem.name}}</div>

                                <!-- 四级 -->
                                <ul v-if="threeitem.children && threeitem.children.length > 0">
                                    <li v-for="(fouritem,index) in threeitem.children">
                                        <div class="tree-detail-images">
                                            <div class="avar">
                                                <el-image
                                                    width="100"
                                                    height="100"
                                                    :src="fouritem.image_url ? fouritem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                    :zoom-rate="1.2"
                                                    :preview-src-list="fouritem.image_url ? [fouritem.image_url] : []"
                                                    :initial-index="10"
                                                    :z-index="15"
                                                    fit="cover"
                                                />
                                                <div class="TTL-setting-image-btn">
                                                <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(fouritem)" />
                                                </div>
                                                <div class="TTL-btn-delete">
                                                <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(fouritem)" />
                                                </div>
                                                <div class="TTL-btn-add">
                                                <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(fouritem)" />
                                                </div>
                                                <div class="TTL-btn-see">
                                                    <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                                    <div class="TTL-genealogy-show">
                                                        <div class="TTL-genealogy-show-img">
                                                            <el-image
                                                                :src="fouritem.image_url ? fouritem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                :zoom-rate="1.2"
                                                                :initial-index="10"
                                                                :z-index="15"
                                                                fit="cover"
                                                            />
                                                        </div>
                                                        <el-row><span>成员名字：{{fouritem.name}}</span></el-row>
                                                        <el-row v-if="fouritem.othername"><span>其他名字：{{fouritem.othername}}</span></el-row>
                                                        <el-row><span>成员性别：{{fouritem.sex==0 ? '男' : '女'}}</span></el-row>
                                                        <el-row><span>成员背景：{{fouritem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                                        <el-row><span>成员职业 / 生前职业：{{fouritem.work}}</span></el-row>
                                                        <el-row v-if="fouritem.isexit==1"><span>是否离世：已离世</span></el-row>
                                                        <el-row><span>成员描述：{{fouritem.description}}</span></el-row>
                                                        <el-row v-if="fouritem.grave_area">
                                                        <span>埋葬地点：{{fouritem.grave_area}}</span>
                                                        <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                                        </el-row>
                                                    </div>
                                                    <template #reference>
                                                    <el-button size="small" type="warning" icon="View" circle />
                                                    </template>
                                                    </el-popover>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="TTL-genealogy-name">{{fouritem.name}}</div>

                                        <!-- 五级 -->
                                        <ul v-if="fouritem.children && fouritem.children.length > 0">
                                            <li v-for="(fiveitem,index) in fouritem.children">
                                                <div class="tree-detail-images">
                                                    <div class="avar">
                                                        <el-image
                                                            width="100"
                                                            height="100"
                                                            :src="fiveitem.image_url ? fiveitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                            :zoom-rate="1.2"
                                                            :preview-src-list="fiveitem.image_url ? [fiveitem.image_url] : []"
                                                            :initial-index="10"
                                                            :z-index="15"
                                                            fit="cover"
                                                        />
                                                        <div class="TTL-setting-image-btn">
                                                        <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(fiveitem)" />
                                                        </div>
                                                        <div class="TTL-btn-delete">
                                                        <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(fiveitem)" />
                                                        </div>
                                                        <div class="TTL-btn-add">
                                                        <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(fiveitem)" />
                                                        </div>
                                                        <div class="TTL-btn-see">
                                                            <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                                            <div class="TTL-genealogy-show">
                                                                <div class="TTL-genealogy-show-img">
                                                                    <el-image
                                                                        :src="fiveitem.image_url ? fiveitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                        :zoom-rate="1.2"
                                                                        :initial-index="10"
                                                                        :z-index="15"
                                                                        fit="cover"
                                                                    />
                                                                </div>
                                                                <el-row><span>成员名字：{{fiveitem.name}}</span></el-row>
                                                                <el-row v-if="fiveitem.othername"><span>其他名字：{{fiveitem.othername}}</span></el-row>
                                                                <el-row><span>成员性别：{{fiveitem.sex==0 ? '男' : '女'}}</span></el-row>
                                                                <el-row><span>成员背景：{{fiveitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                                                <el-row><span>成员职业 / 生前职业：{{fiveitem.work}}</span></el-row>
                                                                <el-row v-if="fiveitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                                                <el-row><span>成员描述：{{fiveitem.description}}</span></el-row>
                                                                <el-row v-if="fiveitem.grave_area">
                                                                <span>埋葬地点：{{fiveitem.grave_area}}</span>
                                                                <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                                                </el-row>
                                                            </div>
                                                            <template #reference>
                                                            <el-button size="small" type="warning" icon="View" circle />
                                                            </template>
                                                            </el-popover>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="TTL-genealogy-name">{{fiveitem.name}}</div>

                                                <!-- 六级 -->
                                                <ul v-if="fiveitem.children && fiveitem.children.length > 0">
                                                    <li v-for="(sixitem,index) in fiveitem.children">
                                                        <div class="tree-detail-images">
                                                            <div class="avar">
                                                                <el-image
                                                                    width="100"
                                                                    height="100"
                                                                    :src="sixitem.image_url ? sixitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                    :zoom-rate="1.2"
                                                                    :preview-src-list="sixitem.image_url ? [sixitem.image_url] : []"
                                                                    :initial-index="10"
                                                                    :z-index="15"
                                                                    fit="cover"
                                                                />
                                                                <div class="TTL-setting-image-btn">
                                                                <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(sixitem)" />
                                                                </div>
                                                                <div class="TTL-btn-delete">
                                                                <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(sixitem)" />
                                                                </div>
                                                                <div class="TTL-btn-add">
                                                                <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(sixitem)" />
                                                                </div>
                                                                <div class="TTL-btn-see">
                                                                    <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                                                    <div class="TTL-genealogy-show">
                                                                        <div class="TTL-genealogy-show-img">
                                                                            <el-image
                                                                                :src="sixitem.image_url ? sixitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                                :zoom-rate="1.2"
                                                                                :initial-index="10"
                                                                                :z-index="15"
                                                                                fit="cover"
                                                                            />
                                                                        </div>
                                                                        <el-row><span>成员名字：{{sixitem.name}}</span></el-row>
                                                                        <el-row v-if="sixitem.othername"><span>其他名字：{{sixitem.othername}}</span></el-row>
                                                                        <el-row><span>成员性别：{{sixitem.sex==0 ? '男' : '女'}}</span></el-row>
                                                                        <el-row><span>成员背景：{{sixitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                                                        <el-row><span>成员职业 / 生前职业：{{sixitem.work}}</span></el-row>
                                                                        <el-row v-if="sixitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                                                        <el-row><span>成员描述：{{sixitem.description}}</span></el-row>
                                                                        <el-row v-if="sixitem.grave_area">
                                                                        <span>埋葬地点：{{sixitem.grave_area}}</span>
                                                                        <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                                                        </el-row>
                                                                    </div>
                                                                    <template #reference>
                                                                    <el-button size="small" type="warning" icon="View" circle />
                                                                    </template>
                                                                    </el-popover>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="TTL-genealogy-name">{{sixitem.name}}</div>

                                                        <!-- 七级 -->
                                                        <ul v-if="sixitem.children && sixitem.children.length > 0"> 
                                                            <li v-for="(seventitem,index) in sixitem.children">
                                                                <div class="tree-detail-images">
                                                                    <div class="avar">
                                                                        <el-image
                                                                            width="100"
                                                                            height="100"
                                                                            :src="seventitem.image_url ? seventitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                            :zoom-rate="1.2"
                                                                            :preview-src-list="seventitem.image_url ? [seventitem.image_url] : []"
                                                                            :initial-index="10"
                                                                            :z-index="15"
                                                                            fit="cover"
                                                                        />
                                                                        <div class="TTL-setting-image-btn">
                                                                        <el-button size="small" type="warning" icon="EditPen" circle  @click="editGenealogy(seventitem)" />
                                                                        </div>
                                                                        <div class="TTL-btn-delete">
                                                                        <el-button size="small" type="danger" icon="Minus" circle  @click="deleteGenealogy(seventitem)" />
                                                                        </div>
                                                                        <div class="TTL-btn-add">
                                                                        <el-button size="small" type="warning" icon="Plus" circle  @click="addGenealogy(seventitem)" />
                                                                        </div>
                                                                        <div class="TTL-btn-see">
                                                                            <el-popover placement="top-start" title="" :width="300" trigger="hover" content="">
                                                                            <div class="TTL-genealogy-show">
                                                                                <div class="TTL-genealogy-show-img">
                                                                                    <el-image
                                                                                        :src="seventitem.image_url ? seventitem.image_url : require('@/assets/avatar/avatar_default.png')"
                                                                                        :zoom-rate="1.2"
                                                                                        :initial-index="10"
                                                                                        :z-index="15"
                                                                                        fit="cover"
                                                                                    />
                                                                                </div>
                                                                                <el-row><span>成员名字：{{seventitem.name}}</span></el-row>
                                                                                <el-row v-if="seventitem.othername"><span>其他名字：{{seventitem.othername}}</span></el-row>
                                                                                <el-row><span>成员性别：{{seventitem.sex==0 ? '男' : '女'}}</span></el-row>
                                                                                <el-row><span>成员背景：{{seventitem.isrelatives==0 ? '直系血亲' : '外嫁旁系'}}</span></el-row>
                                                                                <el-row><span>成员职业 / 生前职业：{{seventitem.work}}</span></el-row>
                                                                                <el-row v-if="seventitem.isexit==1"><span>是否离世：已离世</span></el-row>
                                                                                <el-row><span>成员描述：{{seventitem.description}}</span></el-row>
                                                                                <el-row v-if="seventitem.grave_area">
                                                                                <span>埋葬地点：{{seventitem.grave_area}}</span>
                                                                                <el-button size="small" type="warning" icon="LocationInformation" circle class="address"/>
                                                                                </el-row>
                                                                            </div>
                                                                            <template #reference>
                                                                            <el-button size="small" type="warning" icon="View" circle />
                                                                            </template>
                                                                            </el-popover>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="TTL-genealogy-name">{{seventitem.name}}</div>
                                                            </li>

                                                        </ul>

                                                    </li>
                                                </ul>

                                            </li>
                                        </ul>

                                    </li>

                                </ul>

                            </li>

                        </ul>

                    </li>
                </ul>

            </li>
        </ul>
    </div>

    <!-- 新增、编辑族谱成员信息 -->
    <GenealogyAddEdit 
    :value="genealogyparamtemplate.view" 
    :type="genealogyparamtemplate.type" 
    :data="genealogyparamtemplate.data" 
    @genealogyeditfinish="genealogyfinish" 
    />
       
</template>

<script>
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
import GenealogyAddEdit from '@/views/Home/Module/AddOrEdit.vue';
export default {
    components:{GenealogyAddEdit},
    data() {
        return {

            /** 当前查看的族谱 **/
            Genealogy: {
                id:'',
                loading:false,
            },

            /** 族谱信息列表 **/
            Genealogylists:[],

            /** 族谱数据详情 **/
            Treedata:{
                name: 'root',
                image_url: "http://api.home.com/Upload/middle/avar/20230928/bf05c7bd748f389a872451a363367bbf.png",
                children: [
                    {
                        name: 'children1',
                        image_url: "http://api.home.com/Upload/middle/avar/20230928/bf05c7bd748f389a872451a363367bbf.png"
                    },
                ]
            },

            /** 族谱信息修改 **/
            genealogyparamtemplate: {
                view:false,
                type:'edit',
                data:'',
            },

        }
    },

    mounted() {
        //获取族谱信息列表
        this.getnealogyAll(); 
        //获取族谱信息详情
        let _this=this;
        setTimeout(function() {
            _this.Genealogy.id=_this.Genealogylists[0].id;
            _this.getnealogyDetail();
        },200);
    },

    methods: {

        /** 删除成员 **/
        deleteGenealogy(item) {
            this.$confirm.confirm(
                '该成员删除后会连同下面的所有成员一起删除，且不可恢复，是否要删除？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            )
            .then(()=> {
                INTERFACE_MODEL_GENEALOGY.DEL_GENEALOGY_MEMBER_INFOS({id:item.id,genealogyid:item.genealogyid}).then((res) => {
                    if(res.status > 0) return false;
                    this.getnealogyDetail(); //刷新家谱详情信息
                });
            })
            .catch(()=> {
                
            });
        },


        /** 刷新族谱列表信息 **/
        freshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.getnealogyAll(); //刷新族谱信息列表
            this.getnealogyDetail(); //刷新族谱信息
            load.close(); //关闭loading动画
        },


        /** 切换族谱 **/
        changeGenealogy() {
            this.getnealogyDetail(); //刷新家谱详情信息
        },


        /** 宗族成员信息回调 **/
        genealogyfinish(item) {
            this.genealogyparamtemplate.view=false;
            this.getnealogyDetail(); //刷新族谱信息
        },


        /** 修改成员信息 **/
        editGenealogy(item) {
            this.genealogyparamtemplate.view=true;
            this.genealogyparamtemplate.type='edit';
            this.genealogyparamtemplate.data=item;
        },


        /** 新增成员信息 **/
        addGenealogy(item) {
            this.genealogyparamtemplate.view=true;
            this.genealogyparamtemplate.type='add';
            this.genealogyparamtemplate.data=item;
        },


        /** 新增族长 **/
        addChairman() {
            let item={id:'',genealogyid:this.Genealogy.id,pid:0};
            this.genealogyparamtemplate.view=true;
            this.genealogyparamtemplate.type='add';
            this.genealogyparamtemplate.data=item;
        },


        /** 获取族谱信息列表 **/
        getnealogyAll() {
            this.Genealogylists=[];
            INTERFACE_MODEL_GENEALOGY.GET_GENEALOGY_ALL({}).then((res) => {
                if(res.status > 0) return false;
                this.Genealogylists=res.data;
            });
        },


        /** 获取族谱信息列表 **/
        getnealogyDetail() {
            let _this=this;
            this.Treedata={};
            this.Genealogy.loading=true;
            INTERFACE_MODEL_GENEALOGY.GET_GENEALOGY_INFOS({id:this.Genealogy.id}).then((res) => {
                this.Genealogy.loading=false;
                if(res.status > 0) return false;
                console.log(res.data);
                _this.Treedata=res.data;
            });
        },


    },

}
</script>
<style lang="scss" Scoped>

.tree-detail-infos {width:200px;display:inline-block;padding:10px;}
.tree-detail-images {width:100%;display:flex;justify-content:center;}
.tree-detail-images .avar {width:80px;height:80px;position:relative;}
.tree-detail-images .el-image {width:80px;height:80px;border-radius:50%;}
.TTL-btn-delete {position:absolute;padding:5px;background:#ffffff;border-radius:50%;display:flex;justify-content:center;align-items:center;left:-10px;bottom:-10px;}
.TTL-btn-add {position:absolute;padding:5px;background:#ffffff;border-radius:50%;display:flex;justify-content:center;align-items:center;margin-left:22px;bottom:-10px;}
.TTL-btn-see {position:absolute;padding:5px;background:#ffffff;border-radius:50%;display:flex;justify-content:center;align-items:center;top:-10px;right:-10px;}
.TTL-genealogy-show {width:100%;padding:10px;}
.TTL-genealogy-show-img {width:100%;text-align:center;padding:5px 0;}
.TTL-genealogy-show-img .el-image {width:70px !important;height:70px !important;border-radius:50%;}
.TTL-genealogy-show .el-row {justify-content:left;padding:5px 15px 5px 0;}
.TTL-genealogy-show .el-row span {line-height:23px;}
.TTL-genealogy-show .el-row .address {margin-left:10px;}
.TTL-genealogy-name {margin-top:10px;font-size:13px;line-height:23px;letter-spacing:1px;color:#606266;}
.TTL-genealogy-description {margin-top:5px;margin-bottom:10px;font-size:13px;line-height:23px;letter-spacing:1px;color:#909399;}

* {margin: 0;padding: 0;}
.tree {float:left;width:100%;display:flex;justify-content:center;overflow-x:auto;padding:20px 0 50px 0;}
.tree::-webkit-scrollbar {width:2;height:2;border-radius:15px;background:#D4D7DE;}

.tree ul {
	padding-top: 20px;
	position: relative;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
    display:flex;
    justify-content:center;
}

.tree li {
	float: left;
	text-align: center;
	list-style-type: none;
	position: relative;
	padding: 20px 20px 0 20px;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before, .tree li::after {
	content: '';
	position: absolute;
	top: 0;
	right: 50%;
	border-top: 1px solid #ccc;
	width: 50%;
	height: 20px;
}

.tree li::after {
	right: auto;
	left: 50%;
	border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
any siblings*/
.tree li:only-child::after, .tree li:only-child::before {
	display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
	padding-top: 0;
}

/*Remove left connector from first child and 
right connector from last child*/
.tree li:first-child::before, .tree li:last-child::after {
	border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
	border-right: 1px solid #ccc;
	border-radius: 0 5px 0 0;
	-webkit-border-radius: 0 5px 0 0;
	-moz-border-radius: 0 5px 0 0;
}

.tree li:first-child::after {
	border-radius: 5px 0 0 0;
	-webkit-border-radius: 5px 0 0 0;
	-moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
	content: '';
	position: absolute;
	top: 0;
	left: 50%;
	border-left: 1px solid #ccc;
	width: 0;
	height: 20px;
}

.tree li a {
	border: 1px solid #ccc;
	padding: 5px 10px;
	text-decoration: none;
	color: #666;
	font-family: arial, verdana, tahoma;
	font-size: 11px;
	display: inline-block;
	border-radius: 5px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover, .tree li a:hover+ul li a {
	background: #c8e4f8;
	color: #000;
	border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a:hover+ul li::after, 
.tree li a:hover+ul li::before, 
.tree li a:hover+ul::before, 
.tree li a:hover+ul ul::before {
	border-color: #94a0b4;
}
</style>